module.exports = __webpack_public_path__ + "img/full4-min.95b7c670.png";